import { useState } from "react";
import DayPicker from "react-day-picker/DayPickerInput";
import { DateUtils } from "react-day-picker";

import "react-day-picker/lib/style.css";

import dateFnsFormat from "date-fns/format";
import dateFnsParse from "date-fns/parse";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import TextField from "@mui/material/Button";

const AddTask = ({ onAddTask }) => {
    const [text, setText] = useState("");
    const [day, setDay] = useState("");
    const [reminder, setReminder] = useState(false);

    const dmy_format = "dd/MM/yyyy";
    // var options = {
    //   weekday: "long",
    //   year: "numeric",
    //   month: "long",
    //   day: "numeric",
    //   hour: "2-digit",
    //   minute: "2-digit",
    //   second: "2-digit",
    //   hour12: false,
    // };

    function parseDate(str, format, locale) {
        const parsed = dateFnsParse(str, format, new Date(), { locale });
        if (DateUtils.isDate(parsed)) {
            return parsed;
        }
        return undefined;
    }

    function formatDate(date, format, locale) {
        const formatted = dateFnsFormat(date, dmy_format, { locale });
        // var prnDt = date.toLocaleTimeString(undefined, options);
        setDay(formatted);
        return formatted;
    }

    const handleTextChange = (text) => {
        if (text.length <= 25) {
            setText(text);
        }
    };

    // validation
    // call on event to prevent default page redirection
    const onSubmit = (e) => {
        e.preventDefault();
        if (!text) {
            alert("Enter a task!");
            return;
        } else if (!day) {
            alert("Enter a date!");
            return;
        }

        const parts = day.split("/");
        const year = parts[2];
        const month = parts[1];
        const date = parts[0];

        // Return the formatted date as yyyy-mm-dd
        const formattedDay = `${year}-${month}-${date}`;

        onAddTask({ text, day: formattedDay, reminder });
        setText("");
        //setDay('')
        setReminder(false);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <form className="add-form" onSubmit={onSubmit}>
                <div className="form-control">
                    <label>Task</label>
                    <input
                        type="text"
                        // placeholder="Feed the cat!"
                        value={text}
                        onChange={(e) => handleTextChange(e.target.value)}
                    />
                </div>
                <div className="form-control">
                    <label>Date</label>
                    {/* <input type="text" placeholder="March 31st at 5:00pm" value={day} onChange={(e) => setDay(e.target.value)}/> */}
                    <DayPicker
                        formatDate={formatDate}
                        format={dmy_format}
                        parseDate={parseDate}
                        placeholder={`${dateFnsFormat(new Date(), dmy_format)}`}
                        onFocus={(e) => (e.target.readOnly = true)}
                        //onDayChange={day => console.log(day)}
                    />
                    {/* <DateTimePicker
                        renderInput={(props) => <TextField {...props} />}
                        label="DateTimePicker"
                        value={day}
                        onChange={(e) => {
                            setDay(e);
                        }}
                    /> */}
                </div>
                <div className="form-control form-control-check">
                    <label>Set Completed</label>
                    <input
                        type="checkbox"
                        checked={reminder}
                        value={reminder}
                        onChange={(e) => setReminder(e.currentTarget.checked)}
                    />
                </div>
                <div className="form-control">
                    <input
                        type="submit"
                        value="Add Task"
                        className="btn btn-block"
                    />
                </div>
            </form>
        </LocalizationProvider>
    );
};

export default AddTask;
